var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",style:(_vm.tagStyle)},[_c('img',{staticClass:"tag_icon",attrs:{"src":require("@/assets/icons/icon_tag.png"),"alt":""}}),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }